/** Generate a unique session id for analytics / consent (impure; call from event handlers only). */
export function createSessionId(): string {
  return `session_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}
